import { Base } from '@studiometa/js-toolkit';

/**
 * @typedef {import('@studiometa/js-toolkit').BaseProps} BaseProps
 * @typedef {{}} GalleryGridProps
 */

/**
 * GalleryGrid GalleryGrid.
 * @template {BaseProps} [T=BaseProps]
 * @augments {Base<T & GalleryGridProps>}
 */
export default class GalleryGrid extends Base {
  isOpen = false;

  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'GalleryGrid',
    refs: ['close'],
  };

  /**
   * @type {HTMLElement}
   */
  __header;

  /**
   * Page main header.
   * @returns {HTMLElement}
   */
  get header() {
    if (!this.__header) {
      this.__header = document.querySelector('.main-header');
    }

    return this.__header;
  }

  /**
   * Close on click.
   */
  onCloseClick() {
    this.closeGallery();
  }

  /**
   * Open the gallery.
   */
  openGallery() {
    this.isOpen = true;
    this.header.style.zIndex = '0';
    this.$el.classList.remove('opacity-0', 'pointer-events-none');
  }

  /**
   * Close the gallery.
   */
  closeGallery() {
    this.isOpen = false;
    this.header.style.zIndex = '';
    this.$el.classList.add('opacity-0', 'pointer-events-none');
  }

  /**
   * Close panel when type on Escape key
   * @param {import('@studiometa/js-toolkit').KeyServiceProps} props
   */
  keyed({ ESC }) {
    if (ESC) {
      this.closeGallery();
    }
  }
}
